
import { defineComponent, onMounted, reactive, ref } from 'vue';
import Button from '@/components/ui-elements/form/Button.vue';
import CardFooter from '@/components/ui-elements/card/CardFooter.vue';
import { Form } from '@/components/ui-elements';
import InlineAlert from '@/components/ui-elements/InlineAlert.vue';
import Input from '@/components/ui-elements/form/Input.vue';
import SettingsLayout from '@/components/layouts/SettingsLayout.vue';
import { useUserStore } from '@/store';

export default defineComponent({
	components: {
		Button,
		CardFooter,
		Form,
		InlineAlert,
		Input,
		SettingsLayout,
	},
	setup() {
		const userStore = useUserStore();
		const form = reactive({
			email: {
				rules: ['required', 'email'],
				value: '',
			},
			first_name: {
				rules: ['required', 'min:3'],
				value: '',
			},
			last_name: {
				rules: ['required', 'min:3'],
				value: '',
			},
		});
		const isSuccess = ref(false);
		const showAlert = ref(false);
		const valid = ref(false);

		onMounted(() => {
			form.email.value = userStore.user.email ?? '';
			form.first_name.value = userStore.user.first_name ?? '';
			form.last_name.value = userStore.user.last_name ?? '';
		});

		const handleSave = async () => {
			const { success } = await userStore.updateProfile({
				email: form.email.value,
				first_name: form.first_name.value,
				last_name: form.last_name.value,
			});
			if (success) {
				isSuccess.value = true;
				valid.value = false;
			}
			showAlert.value = true;
		};

		return { form, handleSave, isSuccess, showAlert, valid };
	},
});
